export const questionsData = {
	gender: {
		options: {
			male: {
				value: 'male'
			},
			female: {
				value: 'female'
			}
		}
	},
	goal: {
		options: {
			lose_weight: {
				value: 'lose_weight',
				description: 'lose_weight_description'
			},
			body_tone_up: {
				gender: 'male',
				value: 'body_tone_up',
				description: 'body_tone_up_description'
			},
			love_myself: {
				gender: 'female',
				value: 'love_myself',
				description: 'love_myself_description'
			},
			gain_muscles: {
				gender: 'male',
				value: 'gain_muscles',
				description: 'gain_muscles_description'
			},
			gain_muscles_female: {
				gender: 'female',
				value: 'gain_muscles_female',
				description: 'gain_muscles_description_female'
			},
			gain_flexibility: {
				value: 'gain_flexibility',
				description: 'gain_flexibility_description'
			},
			gain_build_endurance: {
				value: 'gain_build_endurance',
				description: 'gain_build_endurance_description'
			},
			gain_healthier_life: {
				value: 'gain_healthier_life',
				description: 'gain_healthier_life_description'
			}
		}
	},
	goalB: {
		options: {
			lose_weight: {
				value: 'lose_weight',
				description: 'lose_weight_description'
			},
			body_tone_up: {
				gender: 'male',
				value: 'body_tone_up',
				description: 'body_tone_up_description'
			},
			love_myself: {
				gender: 'female',
				value: 'love_myself',
				description: 'love_myself_description'
			},
			gain_muscles: {
				gender: 'male',
				value: 'gain_muscles',
				description: 'gain_muscles_description'
			},
			gain_muscles_female: {
				gender: 'female',
				value: 'gain_muscles_female',
				description: 'gain_muscles_description_female'
			},
			gain_flexibility: {
				value: 'gain_flexibility',
				description: 'gain_flexibility_description'
			},
			gain_build_endurance: {
				value: 'gain_build_endurance',
				description: 'gain_build_endurance_description'
			},
			gain_healthier_life: {
				value: 'gain_healthier_life',
				description: 'gain_healthier_life_description'
			}
		}
	},
	colored_options_start_screen: {
		options: {
			body_tone_up: {
				value: 'body_tone_up',
				description: 'body_tone_up_description'
			},
			love_myself: {
				value: 'love_myself',
				description: 'love_myself_description'
			},
			gain_muscles: {
				value: 'gain_muscles',
				description: 'gain_muscles_description'
			},
			lose_weight: {
				value: 'lose_weight',
				description: 'lose_weight_description'
			},
		}
	},
	goal_three: {
		options: {
			feel_better: {
				value: 'feel_better',
			},
			improve_health: {
				value: 'improve_health',
			},
			both: {
				value: 'both',
			}
		}
	},
	activities_preferences: {
		options: {
			fitness: {
				value: 'fitness'
			},
			walking: {
				value: 'walking'
			},
			running: {
				value: 'running'
			},
			yoga: {
				value: 'yoga'
			},
			dance: {
				value: 'dance'
			},
			gym: {
				value: 'gym'
			}
		}
	},
	age: {
		options: {
			'18-29': {
				value: '18-29'
			},
			'30-39': {
				value: '30-39'
			},
			'40-49': {
				value: '40-49'
			},
			'50-59+': {
				value: '50-59+'
			}
		}
	},
	zones_start_screen: {
		options: {
			abs: {
				value: 'abs'
			},
			glutes: {
				value: 'glutes'
			},
			armpits: {
				value: 'armpits'
			},
			thighs: {
				value: 'thighs'
			}
		}
	},
	diet_type: {
		options: {
			all: {
				value: 'all',
				description: 'all_description'
			},
			vegetarian: {
				value: 'vegetarian',
				description: 'vegetarian_description'
			},
			vegan: {
				value: 'vegan',
				description: 'vegan_description'
			},
			keto: {
				value: 'keto',
				description: 'keto_description'
			}
		}
	},
	current_level: {
		options: {
			beginner: {
				value: 'beginner',
				description: 'beginner_description'
			},
			intermediate: {
				value: 'intermediate',
				description: 'intermediate_description'
			},
			advanced: {
				value: 'advanced',
				description: 'advanced_description'
			}
		}
	},
	zones: {
		options: {
			arm_back: {
				value: 'arm_back'
			},
			abs_core: {
				value: 'abs_core'
			},
			legs_glutes: {
				value: 'legs_glutes'
			}
		}
	},
	motivation: {
		options: {
			tips: {
				value: 'tips'
			},
			body_changes: {
				value: 'body_changes'
			},
			training_progress: {
				value: 'training_progress'
			},
			comunity: {
				value: 'comunity'
			},
			coachs: {
				value: 'coachs'
			},
			apple_rings: {
				value: 'apple_rings'
			}
		}
	},
	frequency: {
		options: {
			minimum: {
				value: 'minimum',
				description: 'minimum_description'
			},
			normal: {
				value: 'normal',
				description: 'normal_description',
				design: 'titleWithLabel'
			},
			maximum: {
				value: 'maximum',
				description: 'maximum_description'
			}
		}
	},
	duration: {
		options: {
			minimum: {
				value: 'minimum',
				description: 'minimum_description'
			},
			normal: {
				value: 'normal',
				description: 'normal_description'
			},
			maximum: {
				value: 'maximum',
				description: 'maximum_description'
			},
			undefined: {
				value: 'undefined',
				description: 'undefined_description'
			}
		}
	},
	sleep: {
		options: {
			extra_low: {
				value: 'extra_low'
			},
			low: {
				value: 'low'
			},
			normal: {
				value: 'normal'
			},
			maximum: {
				value: 'maximum'
			}
		}
	},
	water: {
		options: {
			extra_low: {
				value: 'extra_low'
			},
			low: {
				value: 'low'
			},
			normal: {
				value: 'normal'
			},
			maximum: {
				value: 'maximum'
			}
		}
	},
	motivation_rate: {
		options: {
			low: {
				value: 'low'
			},
			normal: {
				value: 'normal'
			},
			maximum: {
				value: 'maximum'
			}
		}
	},
	life_changes: {
		options: {
			ideal_weight: {
				value: 'ideal_weight'
			},
			more_confident: {
				value: 'more_confident'
			},
			much_happier: {
				value: 'much_happier'
			},
			new_person: {
				value: 'new_person'
			}
		}
	},
	last_time_ideal_weight: {
		options: {
			year_ago: {
				value: 'year_ago'
			},
			'1_2_years_ago': {
				value: '1_2_years_ago'
			},
			'3+_years_ago': {
				value: '3+_years_ago'
			},
			never: {
				value: 'never'
			}
		}
	},
	nutrition_approaches: {
		options: {
			fasting: {
				value: 'fasting',
				description: 'fasting_description'
			},
			calorie_counting: {
				value: 'calorie_counting',
				description: 'calorie_counting_description'
			},
			nutrient_counting: {
				value: 'nutrient_counting',
				description: 'nutrient_counting_description'
			},
			water_traking: {
				value: 'water_traking',
				description: 'water_traking_description'
			},
			none: {
				value: 'none',
				description: ''
			}
		}
	},
	physicall_active: {
		options: {
			extra_low: {
				value: 'extra_low',
				description: 'extra_low_description'
			},
			low: {
				value: 'low',
				description: 'low_description'
			},
			normal: {
				value: 'normal',
				description: 'normal_description'
			},
			maximum: {
				value: 'maximum',
				description: 'maximum_description'
			}
		}
	},
	exercises_time: {
		options: {
			morning: {
				value: 'morning'
			},
			day: {
				value: 'day'
			},
			evening: {
				value: 'evening'
			},
			not_sure: {
				value: 'not_sure'
			}
		}
	},
	diseases: {
		options: {
			diabetes: {
				value: 'diabetes'
			},
			astma: {
				value: 'astma'
			},
			joint: {
				value: 'joint'
			},
			none: {
				value: 'none'
			}
		}
	},
	medications: {
		options: {
			vitamins: {
				value: 'vitamins'
			},
			hormones: {
				value: 'hormones'
			},
			antibiotics: {
				value: 'antibiotics'
			},
			notherone: {
				value: 'other'
			},
			none: {
				value: 'none'
			}
		}
	},
	fat: {
		options: {
			0: {
				value: '4-11%'
			},
			1: {
				value: '11-18%'
			},
			2: {
				value: '18-25%'
			},
			3: {
				value: '25-33%'
			},
			4: {
				value: '33-40%'
			},
			5: {
				value: '40-47%'
			},
			6: {
				value: '47-54%'
			},
			7: {
				value: '54+%'
			}
		}
	},
	health_issues: {
		options: {
			covid: {
				value: 'covid',
				description: 'covid_description'
			},
			jumps: {
				value: 'jumps',
				description: 'jumps_description'
			},
			back: {
				value: 'back',
				description: 'back_description'
			},
			arms: {
				value: 'arms',
				description: 'arms_description'
			},
			joints: {
				value: 'joints',
				description: 'joints_description'
			},
			knees: {
				value: 'knees',
				description: 'knees_description'
			},
			hernia: {
				value: 'hernia',
				description: 'hernia_description'
			},
			none: {
				value: 'none'
			}
		}
	},
	devices: {
		options: {
			bands: {
				value: 'bands'
			},
			barbell: {
				value: 'barbell'
			},
			treadmill: {
				value: 'treadmill'
			},
			dumbells: {
				value: 'dumbells'
			},
			none: {
				value: 'none'
			}
		}
	},
	previous_fails: {
		options: {
			motivation: {
				value: 'motivation'
			},
			plan: {
				value: 'plan'
			},
			hard: {
				value: 'hard'
			},
			coaching: {
				value: 'coaching'
			},
			none: {
				value: 'none'
			}
		}
	},
	motivates_exercise: {
		options: {
			health: {
				value: 'health'
			},
			immune: {
				value: 'immune'
			},
			looking_better: {
				value: 'looking_better'
			},
			strength: {
				value: 'strength'
			},
			libido: {
				value: 'libido'
			}
		}
	},
	focus: {
		options: {
			physical: {
				value: 'physical'
			},
			diet: {
				value: 'diet'
			},
			sleep: {
				value: 'sleep'
			},
			mindful: {
				value: 'mindful'
			}
		}
	},
	successfully_lost_weight: {
		options: {
			yes: {
				value: 'yes'
			},
			no: {
				value: 'no'
			}
		}
	},
	kids: {
		options: {
			no: {
				value: 'no'
			},
			toddlers: {
				value: 'toddlers'
			},
			grown: {
				value: 'grown'
			}
		}
	},
	noise_free: {
		options: {
			yes: {
				value: 'no'
			},
			no: {
				value: 'yes'
			}
		}
	},
	post_covid: {
		options: {
			no: {
				value: 'no'
			},
			over_six_months: {
				value: 'over_six_months'
			},
			within_six_months: {
				value: 'within_six_months'
			}
		}
	},
	emotional_eating: {
		options: {
			yes: {
				value: 'yes'
			},
			no: {
				value: 'no'
			}
		}
	},
	body_type: {
		options: {
			apple: {
				value: 'apple',
				description: 'apple_description'
			},
			pear: {
				value: 'pear',
				description: 'pear_description'
			},
			square: {
				value: 'square',
				description: 'square_description'
			},
			trapezoid: {
				gender: 'male',
				value: 'trapezoid',
				description: 'trapezoid_description'
			},
			hourglass: {
				gender: 'female',
				value: 'hourglass',
				description: 'hourglass_description'
			},
			triangle: {
				value: 'triangle',
				description: 'triangle_description'
			},
			unknown: {
				value: 'unknown',
				description: 'unknown_description'
			}
		}
	},
	weight: {},
	target_weight: {},
	height: {},
	mail: {},
	intermittent_fasting: {}
};
